<template>
  <div class="ui large modal" ref="modal">
    <!-- <i class="close icon"></i> -->
    <div class="header">
      <i class="hand pointer icon"></i>
      {{ $t("environment selection") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/environments.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui three link cards">
          <div
            class="ui card"
            v-for="(environment, eidx) in environments"
            :key="eidx"
            @click="select_environment(environment)"
          >
            <div class="content">
              <a class="header">{{ environment.name }}</a>
              <div class="description">
                <div class="ui bulleted list">
                  <div
                    class="item"
                    v-for="(variable, vidx) in environment.variables"
                    :key="vidx"
                  >
                    <b>{{ variable.name }}</b> {{ variable.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <pre>{{ environments }}</pre> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled button" @click="close">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from "lodash";

export default {
  name: "NgineComposerHumanTaskTesterEnvironmentModal",
  components: {},
  computed: {
    environments() {
      let vm = this;
      if (vm.variables) {
        let grouped = groupBy(vm.variables, (v) => {
          return v.environment;
        });
        return Object.keys(grouped).map((g) => {
          return { name: g, variables: grouped[g] };
        });
      } else {
        return [];
      }
    },
  },
  data() {
    return {
      variables: [],
    };
  },
  methods: {
    show_modal(variables) {
      let vm = this;
      if (variables) vm.variables = variables;

      window
        .jQuery(vm.$refs.modal)
        .modal({
          closable: false,
          onVisible() {},
          onHide() {},
        })
        .modal("show");
    },
    select_environment(environment) {
      let vm = this;
      vm.$emit("environment_selected", environment);
      window.jQuery(vm.$refs.modal).modal("hide");
    },
    close() {
      window.close();
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
